import { retryRequest } from '@/utils/request'
import { AxiosPromise } from 'axios'
import * as PersonalBook from '@/interfaces/personalbook'

export function setBookOrderInfo (data: PersonalBook.IBookOrderRequest): AxiosPromise<any> {
  return retryRequest({
    url: '/128_SetOrderInfoServer_v2_tok.php',
    method: 'post',
    timeout: 60000,
    data
  })
}
